import type { EditableCxRumEvent } from '@coralogix/browser'

export function isTokenExpiredEvent(event: EditableCxRumEvent): boolean {
  const responsePayload = event.network_request_context?.response_payload
  if (typeof responsePayload === 'string' && responsePayload.includes('"errorCode":"token-expired"')) {
    return true
  }
  const customData = event.error_context?.error_custom_data as
    | { response?: { data?: { errorCode?: string } } }
    | undefined
  return customData?.response?.data?.errorCode === 'token-expired'
}

export function isAxiosRequestCanceledEvent(event: EditableCxRumEvent): boolean {
  return event.error_context?.error_message === 'config is undefined'
}

export function isNetworkErrorEvent(event: EditableCxRumEvent): boolean {
  const message = event.error_context?.error_message
  return typeof message === 'string' && /network error/i.test(message)
}
